import { render, staticRenderFns } from "./EWTrxHistoryShow.vue?vue&type=template&id=527710db&"
import script from "./EWTrxHistoryShow.vue?vue&type=script&lang=js&"
export * from "./EWTrxHistoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports